
import PublicPlayerAvatar from "../../public/component/public_player_avatar";

const { ccclass, property } = cc._decorator;

@ccclass
export default class TablePlayerAvatar extends PublicPlayerAvatar{

    @property(cc.Animation)
    scoreChangeAnim: cc.Animation = null

    //位于头像与名字id之间的节点
    @property(cc.Node)
    midNode : cc.Node = null;

    /**
     * 遮罩节点
     */
    @property(cc.Node)
    maskNode : cc.Node = null;


    onLoad(){
        super.onLoad()       
    }

    showMask(show : boolean){

        this.maskNode && (this.maskNode.active = show)
    }

    playScoreChangeAnim(onFinish?){
        let anim = this.scoreChangeAnim        
        anim.play()
        this.scheduleOnce(()=>{
            onFinish && onFinish()
        }, 0.3)
    }

    reset(){
        super.reset()
    }

}